import { FormikProps } from 'formik'
import {
  updateDays,
  updateSingleDayShifts,
} from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import {
  TDay,
  TSingleDayShift,
} from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { DATE_FORMAT_STRING } from '@src/helpers/constants/constants'
import { getFinalDay } from '@src/helpers/timeAndDateHelpers'
import { format } from 'date-fns'
import { INewEditModalFormValues } from '../../new-edit-modal.form'

const getUpdatedDays = (
  value: string,
  isHourStart: boolean,
  vDays: TDay[],
  vIndividualDays: TDay[],
  vSingleDayShifts: TSingleDayShift[]
) => {
  const days = updateDays(vDays, (day) => {
    const { day_start, hour_start, hour_end } = day
    const day_end = getFinalDay(
      day_start,
      isHourStart ? value : hour_start,
      isHourStart ? hour_end : value
    )
    const date_end = format(day_end, DATE_FORMAT_STRING.MM_dd_yyyy)
    return {
      ...(isHourStart ? { hour_start: value } : { hour_end: value }),
      day_end,
      date_end,
    }
  })

  const individualDays = updateDays(vIndividualDays, (day) => {
    const { day_start, hour_start, hour_end } = day
    const day_end = getFinalDay(
      day_start,
      isHourStart ? value : hour_start,
      isHourStart ? hour_end : value
    )
    const date_end = format(day_end, DATE_FORMAT_STRING.MM_dd_yyyy)
    return {
      ...(isHourStart ? { hour_start: value } : { hour_end: value }),
      day_end,
      date_end,
    }
  })

  const singleDayShifts = updateSingleDayShifts(
    vSingleDayShifts,
    isHourStart ? 'hour_start' : 'hour_end',
    value
  )

  return { days, individualDays, singleDayShifts }
}

export const handleHourChange = (
  value: string,
  isHourStart: boolean,
  formik: FormikProps<INewEditModalFormValues>
) => {
  const { setFieldValue, values } = formik

  const fieldName = isHourStart ? 'hour_start' : 'hour_end'

  setFieldValue(fieldName, value)

  const { days } = getUpdatedDays(value, isHourStart, values.days, [], [])

  setFieldValue('days', days)
}
